import { ApiOutlined, PhoneFilled } from '@ant-design/icons';
import { Button, Checkbox, Input, Popconfirm, message } from 'antd';
import get from 'lodash/get';
import { Component } from 'react';
import { withApollo } from 'react-apollo';
import {
	ReferralQuestionsDetailsComponent,
	WebIcon,
} from 'src/_shared/components/';
import { withListReferralQuestions } from '../../api/components/referral-questions/withListReferralQuestionsProvider.js';
import linkedIn from '../../assets/linkedin-logo.png';
import twitter from '../../assets/twitter.png';
import {
	compose,
	downloadFromS3Signed,
	findWithAttr as findWithAttribute,
	formatPhoneNumber,
	ml,
} from '../../services/utils';
import { COLORS } from '../../styles/colors';
import { OnDeckReferralModal } from '../on-deck/on-deck-modal';
import OnDeckComments from './OndeckCommentsComponent.jsx';
import ReferralComments from './ReferralCommentsComponent.jsx';
import {
	BioContainer,
	BioContainerExt as BioContainerExtension,
	SocialIcon,
} from './referralDetailCardStyles.js';
import PermissionGate from 'src/_shared/components/permission-gate/PermissionGate.jsx';

function safeParseArray(jsonString, defaultVal = []) {
	try {
		const parsed = JSON.parse(jsonString);
		return Array.isArray(parsed) ? parsed : defaultVal;
	} catch (err) {
		console.error('Error parsing JSON:', err);
		return defaultVal;
	}
}

class ReferralDetailsCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			contactNotes: get(props.referral, 'adminNote', ''),
			editNotes: false,
			editedFirstName: '',
			editedLastName: '',
			editedEmail: '',
			editedAtsId: '',
			editedPhone: '',
			editedLocation: '',
			editedLinkedin: '',
			editedFacebook: '',
			editedTwitter: '',
			edit: false,
			addPosition: false,
			editedJobs: [],
			theme: JSON.parse(props?.currentUser?.company?.theme || '{}'),
			panelactiveKey: '0',
			diversityHire: false,
			s3Url: '',
			questionValues: {},
			referral: props.referral,
			saving: false,
		};
		this.handleChange = this.handleChange.bind(this);
	}

	componentDidMount() {
		this.setState({
			editedAtsId: this.props.referral.ownershipAtsId,
			editedFirstName: this.props.referral.firstName,
			editedLastName: this.props.referral.lastName,
			editedEmail: this.props.referral.emailAddress,
			editedPhone: this.props.referral.phone,
			editedLocation: this.props.referral.location,
			editedLinkedin: this.props.referral.linkedin,
			editedFacebook: this.props.referral.facebook,
			editedTwitter: this.props.referral.Twitter,
			editedJobs: this.props.referral.employment,
			contactNotes: get(this.props.referral, 'adminNote', ''),
			diversityHire: get(this.props.referral, 'diversityHire', false),
		});
	}

	handleQuestionsChange = (_changedValues, allValues) => {
		this.setState({ questionValues: allValues });
	};

	handleDiversityHireChange = (e) => {
		this.setState({ diversityHire: e.target.checked });
	};

	handleDownloadClick = async (e, key, bucket) => {
		e.preventDefault(); // Prevent default anchor behavior
		try {
			const url = await downloadFromS3Signed(key, bucket);
			// Open in new tab
			window.open(url, '_blank', 'noopener,noreferrer');
		} catch (error) {
			console.error('Error getting download URL:', error);
			message.error('Failed to download resume');
		}
	};

	cancelEdit = () => {
		message.error('Edit Cancelled');
		this.setState({ edit: false });
	};

	confirmEdit = () => {
		this.setState({ saving: true });
		try {
			const { onUpdate, onUpdateReferral } = this.props;
			const {
				editedAtsId,
				editedFirstName,
				editedLastName,
				editedEmail,
				editedLinkedin,
				editedFacebook,
				editedTwitter,
				editedJobs,
				editedPhone,
				questionValues,
				referral,
			} = this.state;

			if (
				(this.props.referral.emailAddress &&
					(editedEmail === '' || editedEmail === null)) ||
				(!editedEmail && !editedPhone)
			) {
				message.error('Need email or phone to save');
				this.setState({
					editedEmail: this.props.referral.emailAddress,
					editedPhone: this.props.referral.phone,
				});
				return null;
			}

			const originalReferrals =
				this.props.referrals || this.props.referral?.referrals;
			// Create a deep clone of the referrals array to avoid modifying the original
			const updatedReferrals = JSON.parse(JSON.stringify(originalReferrals));
			let updatedQuestionsData = null;
			let updatedCandidateQuestionsData = null;
			let updatedInterestedQuestionsData = null;

			if (updatedReferrals && updatedReferrals.length > 0) {
				// Safely parse questionsData and candidateQuestionsData
				const currentQuestions = safeParseArray(
					get(updatedReferrals[0], 'questionsData', '[]')
				);

				updatedQuestionsData = currentQuestions.map((question) => {
					const newValue = questionValues[question.name];
					const newText = questionValues[`${question.name}_text`];
					return {
						...question,
						value: newValue !== undefined ? newValue : question.value,
						// Update text if a new dropdown selection was made
						...(newText !== undefined && { text: newText }),
					};
				});

				const currentCandidateQuestions = safeParseArray(
					get(updatedReferrals[0], 'candidateQuestionsData', '[]')
				);
				updatedCandidateQuestionsData = currentCandidateQuestions.map(
					(question) => {
						const newValue = questionValues[question.name];
						const newText = questionValues[`${question.name}_text`];
						return {
							...question,
							value: newValue !== undefined ? newValue : question.value,
							...(newText !== undefined && { text: newText }),
						};
					}
				);
				if (
					currentCandidateQuestions?.length === 0 &&
					referral?.interestedQuestionsData
				) {
					const currentInterestedQuestions = safeParseArray(
						get(referral, 'interestedQuestionsData', '[]')
					);
					updatedInterestedQuestionsData = currentInterestedQuestions.map(
						(question) => {
							const newValue = questionValues[question.name];
							const newText = questionValues[`${question.name}_text`];
							return {
								...question,
								value: newValue !== undefined ? newValue : question.value,
								...(newText !== undefined && { text: newText }),
							};
						}
					);
				}

				// Update the local referrals data
				if (updatedReferrals.length > 0) {
					updatedReferrals[0] = {
						...updatedReferrals[0],
						questionsData: JSON.stringify(updatedQuestionsData),
						candidateQuestionsData: JSON.stringify(
							updatedCandidateQuestionsData
						),
						interestedQuestionsData: JSON.stringify(
							updatedInterestedQuestionsData
						),
					};
				}
			}

			// Update local referral object
			const updatedReferral = {
				...referral,
				firstName: editedFirstName,
				lastName: editedLastName,
				emailAddress: editedEmail ? editedEmail.toLowerCase() : '',
				linkedin: editedLinkedin,
				facebook: editedFacebook,
				Twitter: editedTwitter,
				employment: editedJobs,
				phone: editedPhone,
				contact: {
					...referral.contact,
					firstName: editedFirstName,
					lastName: editedLastName,
				},
				referrals: updatedReferrals,
			};

			// Handle social media updates
			const currentSocials = referral.socialMediaAccounts;
			const newSocials = [];
			const twitterIndex =
				currentSocials !== null
					? findWithAttribute(currentSocials, 'network', 'twitter')
					: -1;
			const facebookIndex =
				currentSocials !== null
					? findWithAttribute(currentSocials, 'network', 'facebook')
					: -1;
			const linkedinIndex =
				currentSocials !== null
					? findWithAttribute(currentSocials, 'network', 'linkedin')
					: -1;

			const newTwitter =
				twitterIndex >= 0 ? { ...currentSocials[twitterIndex] } : null;
			const newFacebook =
				facebookIndex >= 0 ? { ...currentSocials[facebookIndex] } : null;
			const newLinkedin =
				linkedinIndex >= 0 ? { ...currentSocials[linkedinIndex] } : null;

			if (newFacebook !== null) {
				newFacebook.profile = editedFacebook;
				newSocials.push(newFacebook);
			}
			if (newTwitter !== null) {
				newTwitter.profile = editedTwitter;
				newSocials.push(newTwitter);
			}
			if (newLinkedin !== null) {
				newLinkedin.profile = editedLinkedin;
				newSocials.push(newLinkedin);
			}

			const input = {
				firstName: editedFirstName,
				lastName: editedLastName,
				id: referral.id, // The referral from props is actually a contact entity
				socialMediaAccounts:
					newSocials.length > 0 ? JSON.stringify(newSocials) : null,
				phoneNumber: editedPhone,
				userId: referral.userId,
			};
			if (editedAtsId?.length > 0) {
				input.atsId = editedAtsId;
			}
			if (editedEmail?.length > 0) {
				input.emailAddress = editedEmail.toLowerCase();
				input.confirmedEmail = editedEmail.toLowerCase();
			}
			if (editedPhone?.length > 0) {
				input.phoneNumber = editedPhone;
			}

			// First update the local state to show the new values
			this.setState({ referral: updatedReferral });

			onUpdate(input)
				.then(() => {
					const referralInput = {
						id: get(referral, 'referralId'), // The referral from props is actually a contact
						// and the referral data from the url referral id combined
						diversityHire: this.state.diversityHire,
					};
					if (editedAtsId?.length > 0) {
						referralInput.ownershipAtsId = editedAtsId;
					}
					if (questionValues) {
						if (updatedQuestionsData?.length > 0) {
							referralInput.questionsData =
								JSON.stringify(updatedQuestionsData);
						}
						if (updatedCandidateQuestionsData?.length > 0) {
							referralInput.candidateQuestionsData = JSON.stringify(
								updatedCandidateQuestionsData
							);
						}
						if (updatedInterestedQuestionsData?.length > 0) {
							referralInput.interestedQuestionsData = JSON.stringify(
								updatedInterestedQuestionsData
							);
						}
					}
					return onUpdateReferral({
						input: referralInput,
					});
				})
				.then((result) => {
					message.success('Referral Edited');
					this.setState({
						edit: false,
						questionValues: {},
						saving: false,
					});
				})
				.catch((error) => {
					console.error('Error updating referral:', error);
					message.error('Failed to update referral');
					this.setState({ saving: false });
				});
		} catch (error) {
			console.error(error);
		}
	};

	editInfo = () => {
		this.setState({
			edit: true,
		});
	};

	handleCancel = () => {
		this.setState({ edit: false });
	};

	handleChange = (name) => (event) => {
		this.setState({
			[name]: event.target.value,
		});
	};

	render() {
		const {
			addGeneralReferralText,
			allMultiLingualData,
			currentUser,
			referral: oldReferral,
			contact,
			referrals: referralsFromProps,
		} = this.props;
		const referral = contact || oldReferral;
		const referrals = referralsFromProps || referral?.referrals || [];
		let isDeckView = false;
		const questionsData =
			referrals !== null && referrals[0]
				? get(referrals[0], 'questionsData', [])
				: referral
					? get(referral, 'questionsData', [])
					: null;
		const candidateQuestionsData =
			referrals?.[0]?.candidateQuestionsData ||
			referral?.candidateQuestionsData ||
			null;
		const interestedQuestionsData =
			referral === null ? null : (referral?.interestedQuestionsData ?? []);
		const additionalQuestionsData =
			candidateQuestionsData?.length > 0
				? candidateQuestionsData
				: interestedQuestionsData;
		const {
			ownershipAtsId,
			avatar,
			emailAddress,
			phone,
			Twitter,
			linkedin,
			facebook,
			contactResume,
		} = referral;

		if (referral.contact?.onDeckStatus === 'onDeck' && referrals.length === 0) {
			isDeckView = true;
		}

		const { theme } = this.state;
		const firstName = get(referral, 'contact.firstName', ' ');
		const lastName = get(referral, 'contact.lastName', ' ');

		// Edit component fields
		const classContainer =
			Twitter !== null || linkedin !== null || facebook !== null
				? BioContainer
				: BioContainerExtension;
		const editIcon = <Button onClick={this.editInfo}>Edit Referral</Button>;

		const okButton = (
			<div className="profile-right-btn-grp">
				<Popconfirm
					title={ml('Confirm Updates?', currentUser, allMultiLingualData)}
					placement="left"
					okText={ml('Yes', currentUser, allMultiLingualData)}
					cancelText={ml('No', currentUser, allMultiLingualData)}
					onConfirm={this.confirmEdit}
					disabled={this.state.saving}
				>
					<Button type="primary" size="large" loading={this.state.saving}>
						{ml('Save', currentUser, allMultiLingualData)}
					</Button>
				</Popconfirm>
				<Popconfirm
					title={ml('Discard Edits?', currentUser, allMultiLingualData)}
					placement="left"
					okText={ml('Yes', currentUser, allMultiLingualData)}
					cancelText={ml('No', currentUser, allMultiLingualData)}
					onConfirm={this.cancelEdit}
					disabled={this.state.saving}
				>
					<Button
						ghost
						type="primary"
						size="large"
						disabled={this.state.saving}
						style={{ marginLeft: '10px' }}
					>
						{ml('Cancel', currentUser, allMultiLingualData)}
					</Button>
				</Popconfirm>
			</div>
		);

		const editFirstName = (
			<Input
				key="editFirstName"
				id="firstname"
				name="editedFirstName"
				placeholder={ml('First Name', currentUser, allMultiLingualData)}
				value={this.state.editedFirstName}
				className="custom-input"
				onChange={this.handleChange('editedFirstName')}
			/>
		);

		const editLastName = (
			<Input
				key="editLastName"
				id="lastname"
				name="editedLastName"
				placeholder={ml('Last Name', currentUser, allMultiLingualData)}
				value={this.state.editedLastName}
				className="custom-input"
				onChange={this.handleChange('editedLastName')}
			/>
		);

		const editEmail = (
			<Input
				id="email"
				name="editedEmail"
				placeholder={ml('Email', currentUser, allMultiLingualData)}
				value={this.state.editedEmail}
				className="custom-input"
				onChange={this.handleChange('editedEmail')}
			/>
		);

		const editAtsId = (
			<Input
				id="atsId"
				name="editedAtsId"
				placeholder={ml('Candidate ID', currentUser, allMultiLingualData)}
				value={this.state.editedAtsId}
				className="custom-input"
				onChange={this.handleChange('editedAtsId')}
			/>
		);

		const editPhone = (
			<Input
				name="editedPhone"
				placeholder={ml('Phone', currentUser, allMultiLingualData)}
				value={this.state.editedPhone}
				className="custom-input"
				onChange={this.handleChange('editedPhone')}
			/>
		);

		const editLinkedin = (
			<Input
				name="editedLinkedin"
				placeholder="Linkedin"
				value={this.state.editedLinkedin}
				style={{ width: 200 }}
				onChange={this.handleChange('editedLinkedin')}
			/>
		);

		const editFacebook = (
			<Input
				name="editedFacebook"
				placeholder="Facebook"
				value={this.state.editedFacebook}
				style={{ width: 200 }}
				onChange={this.handleChange('editedFacebook')}
			/>
		);

		const editTwitter = (
			<Input
				name="editedTwitter"
				placeholder="Twitter"
				value={this.state.editedTwitter}
				style={{ width: 200 }}
				onChange={this.handleChange('editedTwitter')}
			/>
		);

		const userRole = currentUser?.role || '';
		return (
			<>
				<div className="referrrals-profile-left">
					<div className="rpf-content">
						<div className="custom-image-wrap">
							{avatar === null || avatar === undefined ? (
								<>
									{get(firstName, '[0]', '').toUpperCase()}{' '}
									{get(lastName, '[0]', '').toUpperCase()}
								</>
							) : (
								<img
									className="custom-img"
									src={avatar}
									alt={`${get(firstName, '[0]', '').toUpperCase()} ${get(
										lastName,
										'[0]',
										''
									).toUpperCase()}`}
								/>
							)}
						</div>
						<div className="rpf-content-right">
							{this.state.edit === true ? (
								<div className="custom-form-group cf-frp-name">
									{editFirstName}
									{editLastName}
								</div>
							) : (
								<h2 className="content-right-name">
									{firstName} {lastName}
								</h2>
							)}
							{this.state.edit === true ? (
								<>
									<div className="custom-form-group">{editEmail}</div>
									<div className="custom-form-group">{editAtsId}</div>
								</>
							) : emailAddress === null ? null : (
								<p className="rpfc-right-text">
									<a
										className="content-right-link"
										href={`mailto:${emailAddress}`}
									>
										<i
											className="icon-envelope-outline"
											style={{ fontSize: 18 }}
										/>
										<span>{emailAddress}</span>
									</a>
								</p>
							)}
							{this.state.editedAtsId && this.state.edit !== true && (
								<p className="rpfc-right-text">
									<ApiOutlined
										style={{
											fontSize: 18,
											marginRight: 16,
											verticalAlign: 'text-top',
										}}
									/>
									<span>{ownershipAtsId}</span>
								</p>
							)}
							{this.state.edit === true ? (
								<div className="custom-form-group">{editPhone}</div>
							) : phone === null ? null : (
								<p className="rpfc-right-text">
									<a className="content-right-link" href={`tel:${phone}`}>
										<PhoneFilled />
										<span>{formatPhoneNumber(phone)}</span>
									</a>
								</p>
							)}

							<div className="rpfc-right-icons">
								{linkedin !== null && (
									<>
										<a href={linkedin}>
											<img
												alt="linkedIn"
												className={SocialIcon}
												src={linkedIn}
											/>
										</a>
										{this.state.edit === true && editLinkedin}
									</>
								)}
								{facebook !== null && (
									<>
										<a href={facebook}>
											<WebIcon
												name="facebook-logo"
												size={this.props.size || 18}
												color={COLORS.blue}
											/>
										</a>
										{this.state.edit === true && editFacebook}
									</>
								)}
								{Twitter !== null && (
									<>
										<a href={Twitter}>
											<img alt="twitter" className={SocialIcon} src={twitter} />
										</a>
										{this.state.edit === true && editTwitter}
									</>
								)}
							</div>

							{contactResume && contactResume.key !== null ? (
								<>
									<h4 className="content-right-heading">
										{ml('Resume', currentUser, allMultiLingualData)}
									</h4>
									<p>
										<a
											id="download"
											className="content-right-link"
											href="#" // Placeholder href
											onClick={(e) =>
												this.handleDownloadClick(
													e,
													get(contactResume, 'key'),
													'erin-documents'
												)
											}
										>
											<i className="icon-application" />
											<span>
												{ml(
													'Download Resume',
													currentUser,
													allMultiLingualData
												)}
											</span>
										</a>
									</p>
								</>
							) : null}

							{referrals.length > 0 ? (
								<>
									<ReferralComments
										allMultiLingualData={allMultiLingualData}
										currentUser={currentUser}
										referrals={referrals}
									/>
									{this.state.edit && (
										<div className="custom-form-group my-2">
											<Checkbox
												checked={this.state.diversityHire}
												onChange={this.handleDiversityHireChange}
												style={{
													marginRight: 6,
												}}
											/>
											<label>
												{ml('Diversity Hire', currentUser, allMultiLingualData)}
											</label>
										</div>
									)}
									{questionsData?.length > 0 ||
									additionalQuestionsData?.length > 0 ? (
										<ReferralQuestionsDetailsComponent
											allMultiLingualData={allMultiLingualData}
											currentUser={currentUser}
											questionsData={questionsData}
											candidateQuestionsData={additionalQuestionsData}
											referralUserGroupId={referrals?.[0]?.userGroupId || referral?.userGroupId}
											theme={theme}
											editing={this.state.edit}
											onValuesChange={this.handleQuestionsChange}
										/>
									) : null}
								</>
							) : null}

							{referrals.length === 0 && isDeckView === true ? (
								<div className={classContainer}>
									<OnDeckComments
										allMultiLingualData={allMultiLingualData}
										referrals={referral}
										currentUser={currentUser}
									/>
									{(questionsData !== null && questionsData.length > 0) ||
									(candidateQuestionsData !== null &&
										candidateQuestionsData.length > 0) ? (
										<ReferralQuestionsDetailsComponent
											allMultiLingualData={allMultiLingualData}
											currentUser={currentUser}
											questionsData={questionsData}
											candidateQuestionsData={candidateQuestionsData}
											referralUserGroupId={referrals?.[0]?.userGroupId || referral?.userGroupId}
											theme={theme}
											editing={this.state.edit}
											onValuesChange={this.handleQuestionsChange}
										/>
									) : null}
								</div>
							) : null}
						</div>
					</div>
				</div>
				<div className="referrrals-profile-right">
					{(userRole === 'admin' || userRole === 'superAdmin') && (
						<PermissionGate componentKey="action.referrals.edit">
							<div className="w-100 mb-3">
								{this.state.edit ? okButton : editIcon}
							</div>
						</PermissionGate>
					)}
					{this.props.referral.emailAddress &&
					get(this.props, ['referral', 'onDeckStatus']) !== 'onDeck' ? (
						<OnDeckReferralModal
							button
							jobData={this.props.job}
							minWidth={180}
							contact={this.props.referral}
							referPage="referralDetails"
							addGeJobHneralReferralText={addGeneralReferralText}
						/>
					) : null}
				</div>
			</>
		);
	}
}
export default ReferralDetailsCard;

export const EditableReferralDetailsCard = compose(withListReferralQuestions)(
	withApollo(ReferralDetailsCard)
);
